import { html } from 'lit';

export const heart = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="32px"
  height="32px"
  viewBox="0 0 40 40"
>
  <path
    fill="var(--logo-fill, var(--uui-color-current))"
    d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20s20-9,20-20C40,9,31,0,20,0z M30.4,22.8L30,23.2l-10,10l0,0l0,0l-10-10l0,0  l0,0l-0.3-0.3c0,0,0,0-0.1-0.1l0,0c-2.8-2.8-2.8-7.2,0-10c2.3-2.3,5.7-2.7,8.3-1.2c0.6,0.3,1.2,0.7,1.7,1.3l0.3,0.3v0l0,0l0,0v0  l0.3-0.3c0.5-0.5,1.1-0.9,1.7-1.3c2.7-1.4,6.1-1,8.3,1.2C33.1,15.6,33.1,20.1,30.4,22.8z"
  />
</svg>`;
